import { Dialog, Transition } from "@headlessui/react";
import { Button } from "common/src/styles";
import React, { Fragment, useRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmationModal(_ref) {
  let {
    title = "Please Confirm Decision",
    isOpen = false,
    setIsOpen = () => {
      /**/
    },
    confirmButtonText = "Confirm",
    cancelButtonAction = () => setIsOpen(false),
    children,
    modalStyle = "normal",
    ...props
  } = _ref;
  const cancelButtonRef = useRef(null);
  return /*#__PURE__*/_jsx(Transition.Root, {
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      className: "relative z-10",
      initialFocus: cancelButtonRef,
      onClose: setIsOpen,
      "data-testid": "confirm-modal",
      children: [/*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "fixed inset-0 bg-grey-400 bg-opacity-75 transition-opacity"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "fixed z-10 inset-0 overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0",
          children: /*#__PURE__*/_jsx(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/_jsxs(Dialog.Panel, {
              className: "relative bg-white rounded-3xl pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-md sm:w-full sm:p-6",
              children: [/*#__PURE__*/_jsx("div", {
                className: "sm:items-start",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "mt-3 text-center sm:mt-0 sm:text-left",
                  children: [/*#__PURE__*/_jsx(Dialog.Title, {
                    as: "h3",
                    className: `font-sans text-lg font-medium text-grey-500 ${modalStyle === "wide" ? "text-center" : ""}`,
                    children: title
                  }), /*#__PURE__*/_jsx("div", {
                    className: "mt-2",
                    children: props.body
                  })]
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "button",
                  $variant: "outline",
                  className: `w-full inline-flex text-sm sm:ml-3 bg-blue-100 text-black font-mono px-8 focus:shadow-outline ${modalStyle === "wide" ? "sm_full justify-center" : "sm:w-auto justify-center"}`,
                  onClick: props.confirmButtonAction,
                  "data-testid": "confirm-continue",
                  disabled: props.disabled,
                  children: confirmButtonText
                }), /*#__PURE__*/_jsx(Button, {
                  type: "button",
                  $variant: "outline",
                  className: `w-full inline-flex text-sm sm:ml-3 font-mono px-8 ${modalStyle === "wide" ? "sm_full justify-center" : "sm:w-auto justify-center"}`,
                  onClick: cancelButtonAction,
                  ref: cancelButtonRef,
                  "data-testid": "confirm-cancel",
                  children: "Cancel"
                })]
              })]
            })
          })
        })
      }), children]
    })
  });
}